<template>
  <!-- <div class="test1209 ldBar label-center" data-type="fill" data-img="https://dev-private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div> -->
  <loading :active="releaseType"
            :can-cancel="true"
            :is-full-page="true"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :style="style">
            <!-- <div class="text-center text-blue-50 text-4xl" style="background-color:red;word-wrap:break-word; width:300px;">建立關鍵字...</div>
            <div class="w-2/4" style="background-color:blue;display: flex; justify-content: center; align-items: center; width:300px; ">
              <div style="margin: auto"> -->
                <!-- <circle-progress :percent="releasePercent" :show-percent="true" :class="'text-blue-50 text-4xl'"/> -->
                <div id="releaseFill" class="ldBar label-center" data-type="fill" data-img="https://dev-private.autoturn.net/autoturn_logo_v04.svg" style="width:300px;height:300px;" ></div>
              <!-- </div>
            </div> -->
  </loading>
  <loading 
          v-if="allPageLoading"
          :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <div class="panel bg-white rounded-xl space-y-6 p-6 ml-3" style="height:auto; position:relative;">
    <loading :active="!showTable"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <DataTable
      :value="records"
      :paginator="true"
      class="p-datatable-customers"
      :rows="10"
      dataKey="id"
      :rowHover="true"
      v-model:filters="filters"
      filterDisplay="menu"
      :loading="loading"
      paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
      :rowsPerPageOptions="[10,25,50]"
      :currentPageReportTemplate="`${lang['components']['List']['ListDataTable']['datatable_page_info']}`"
      :globalFilterFields="['campaign_name','status','report','active','updatedDate','pageInfo']"
      responsiveLayout="scroll"
      @page="onPageCange($event)"
    >
      <!-- Header -->
      <template #header class="bg-white">
        <div class="p-d-flex p-jc-between p-ai-center w-full bg-white">
          <span class="p-input-icon-left w-full">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" placeholder="Keyword Search" class="w-full rounded-md" />
          </span>
        </div>
      </template>

      <template #empty>
        No records found.
      </template>

      <template #loading>
        Loading records data. Please wait.
      </template>

      <Column field="campaign_name" :header="`${lang['components']['List']['ListDataTable']['field_a']}`" sortable style="min-width: 10rem">
        <template #body="{data}">
          <span class="data-txt">{{ data.campaign_name }}</span>
        </template>
        <!--<template #filter="{filterModel}">
          <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by name" />
        </template>-->
      </Column>

      <Column field="status" :header="`${lang['components']['List']['ListDataTable']['field_b']}`" sortable style="min-width: 10rem">
        <template #body="{data}">
          <main class="flex items-center">
            <div class="status-tag blue" v-if="data.status === '正式' || data.status === 'official'">
              {{ data.status }}
            </div>
            <div class="status-tag red" v-else-if="(data.status === '草稿' || data.status === 'draft' || data.status === 'Draft') && (data.isActive === '已過期' || data.isActive === '已过期' || data.isActive === 'expired' || data.isActive === 'Expired')">
              {{ lang['components']['List']['ListDataTable']['is_expired'] }}
            </div>
            <div class="status-tag red" v-else-if="data.status === '必填欄位未填齊' || data.status === '必填栏位未填齐' || data.status === 'Required field not filled'">
              {{ data.status }}
            </div>
            <div class="status-tag green" v-else>
              {{ data.status }}
            </div>
            <span class="ml-2 data-txt" v-if="data.status === '正式' || data.status === 'official'">
              {{ data.isActive }}
            </span>
            <span class="ml-2" v-if="data.error_info != ''">
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${data.error_info}`"
              ></i>
            </span>
            <span class="ml-2" v-else-if="data.paused_log != ''">
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="`${data.paused_log}`"
              ></i>
            </span>
          </main>

        </template>
      </Column>

      <Column field="report" :header="`${lang['components']['List']['ListDataTable']['field_c']}`" sortable style="min-width: 10rem">
        <template #body="{data}">
          <!-- <p v-html="data.report"></p> -->
          <main class="flex items-center">
            <div class="flag" v-if="data.report != '尚未產生報表' || data.report != 'Report not yet generated'"></div>
            <span class="ml-2 data-txt" :class="{'grey' : data.report != '尚未產生報表' || data.report != 'Report not yet generated'}" @click="handleClickOpen($event, data.id, data.isActive, data.adaccount_id)">{{ data.report }}</span>
          </main>
        </template>
      </Column>

      <Column field="updatedDate" :header="`${lang['components']['List']['ListDataTable']['field_e']}`" sortable style="min-width: 10rem">
        <template #body="{data}">
          <span class="data-txt">{{ data.updatedDate }}</span>
          <!-- <br />
          <span class="small-txt">{{ data.updatedTime }}</span> -->

        </template>
      </Column>

      <Column field="active" :header="`${lang['components']['List']['ListDataTable']['field_d']}`" style="min-width: 14rem">
        <template #body="{data}">
          <main class="flex items-center">
            <div v-for="(item, idx) in data.actions" :key="idx">
              <ActionIcon :type="item.type" v-tooltip="item.name" @click="campaignActive(data.id, item.type, data.daily_budget, data.budget_increase, data.campaign_name, data.adaccount_id, data.total_budget, data.Target_AD, data.Target_CT, data.sub_campaigns)" />
            </div>
          </main>

        </template>
      </Column>

      <Column field="results" :header="'預估成效/目前成效'" style="min-width: 14rem">
        <template #body="{data}">
          {{ data.results }}
        </template>
      </Column>

      <Column field="sales" :header="'預估銷量/目前銷量'" style="min-width: 14rem">
        <template #body="{data}">
          {{ data.sales }}
        </template>
      </Column>

    </DataTable>
    <OverlayPanel
      ref="previewPanel"
      appendTo="body"
      id="overlay_panel"
      :breakpoints="{'960px': '75vw'}"
      class="rounded-xl"
    >
      <div v-if="!fin">{{lang['components']['List']['ListDataTable']['report_loading_text']}}...</div>
      <h1 v-if="fin" class="overpanel-title">
        {{lang['components']['List']['ListDataTable']['report_loading_title']}}
      </h1>

      <div v-if="fin" class="close-btn" @click="toggle">
        <span class="p-overlaypanel-close-icon pi pi-times"></span>
      </div>

      <div v-if="fin">
        <PanelChart :chartsData="lineStylesData" :tableData="tableData" :title="label" v-bind:chartCampaignId="chartCampaignId" v-bind:chartCampaignAdaccountId="chartCampaignAdaccountId" v-bind:lang="lang" />
      </div>

    </OverlayPanel>

    <Dialog :visible="showDialog">
      <template #header>
        <h2 class="text-xl font-semibold">投遞概況</h2>
      </template>

      <div class="p-6 bg-white rounded-lg shadow-md max-w-2xl mx-auto text-gray-800">
        <h4 class="text-lg font-bold text-primary mb-2">行銷活動設定</h4>

        <div class="space-y-3 mb-6 text-sm overflow-y-auto" style="height:300px;">
          <div class="grid grid-cols-12 gap-2">
            <div class="col-span-3 text-right">行銷活動名稱：</div>
            <div class="col-span-9">123456</div>
            <div class="col-span-3 text-right">行銷方式（USD）：</div>
            <div class="col-span-9">精準興趣：10</div>
            <div class="col-span-3 text-right">受益者：</div>
            <div class="col-span-9">PapL（123456）</div>
            <div class="col-span-3 text-right">出資者：</div>
            <div class="col-span-9">PapL（123456）</div>
            <div class="col-span-3 text-right">精準興趣：</div>
            <div class="col-span-9 flex flex-wrap">
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告1
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告2
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告3
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告4
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告5
              </div>
            </div>
            <div class="col-span-3 text-right">類似受眾：</div>
            <div class="col-span-9 flex flex-wrap">
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告1111111111111111111111111
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告22222222222222222222222
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告3444444444444444444444444444444
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告4555555555555555555555555555555
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告56666666666666666666666666
              </div>
            </div>
            <div class="col-span-3 text-right">類似受眾-推廣網址：</div>
            <div class="col-span-9">
              https://www.autoturn.net/index.php/index/view
            </div>
            <div class="col-span-3 text-right">再行銷：</div>
            <div class="col-span-9 flex flex-wrap">
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告1
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告2
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告3
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告4
              </div>
              <div class="flex rounded m-1 px-2 py-1 text-sm w-none bg-blue-400 text-white bg-blue-400 text-white">
                廣告5
              </div>
            </div>
            <div class="col-span-3 text-right">行銷日期：</div>
            <div class="col-span-9">2025-06-07 - 0000-00-00</div>
            <div class="col-span-3 text-right">目標：</div>
            <div class="col-span-9">轉換次數：購買 - 未來實驗室的像素 - 轉換次數</div>
            <div class="col-span-3 text-right">轉換網域：</div>
            <div class="col-span-9">autoturn.net</div>
            <div class="col-span-3 text-right">目錄銷售-商品組合：</div>
            <div class="col-span-9">商品組合名稱</div>
            <div class="col-span-3 text-right">目錄銷售-事件：</div>
            <div class="col-span-9">購買 - 未來實驗室的像素</div>
            <div class="col-span-3 text-right">應用程式事件：</div>
            <div class="col-span-9">無</div>
            <div class="col-span-3 text-right">目標成本（USD）：</div>
            <div class="col-span-9">10</div>
            <div class="col-span-3 text-right">預算使用：</div>
            <div class="col-span-9">穩健 - 依照成效好壞時下修廣告組合預算，不會超過總預算</div>
            <div class="col-span-3 text-right">預算比率：</div>
            <div class="col-span-9">10 %</div>
            <div class="col-span-3 text-right">地點：</div>
            <div class="col-span-9">台灣</div>
            <div class="col-span-3 text-right">語言：</div>
            <div class="col-span-9">所有語言</div>
            <div class="col-span-3 text-right">性別：</div>
            <div class="col-span-9">全部性別</div>
            <div class="col-span-3 text-right">年齡：</div>
            <div class="col-span-9">18 ~ 65</div>
            <div class="col-span-3 text-right">關係鏈與受眾：</div>
            <div class="col-span-9">無</div>
            <div class="col-span-3 text-right">裝置：</div>
            <div class="col-span-9">桌上型電腦、行動裝置</div>
            <div class="col-span-3 text-right">平台：</div>
            <div class="col-span-9">Faecbook、Instagram、Audience Network、Messenger</div>
            <div class="col-span-3 text-right">特定行動裝置和作業系統：</div>
            <div class="col-span-9">所有行動裝置</div>
            <div class="col-span-3 text-right">身份-Facebook：</div>
            <div class="col-span-9">Autoturn</div>
            <div class="col-span-3 text-right">身份-Instagram：</div>
            <div class="col-span-9">使用所選的粉絲專頁</div>
            <div class="col-span-3 text-right">素材內容：</div>
            <div class="col-span-9 flex flex-col space-y-2 h-96 overflow-y-auto">
              <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                <div class="relative flex justify-between p-1">
                  <div class="md:flex-shrink-0">
                    <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                  </div>
                  <div class="relative flex-grow flex flex-col px-2">
                    <p class="flex-none flex text-lg overflow-hidden">
                      <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                      <span class="w-1/3 mr-4">FaceBook Post</span>
                    </p>
                    <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                    <div class="flex-none flex">
                      <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">24</span>
                      <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">1</span>
                      <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <div class="flex-grow text-right text-gray-500">
                        <span>2024/12/04</span>
                      </div>
                    </div>
                  </div>
                  <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                </div>
              </div>
              <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                <div class="relative flex justify-between p-1">
                  <div class="md:flex-shrink-0">
                    <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                  </div>
                  <div class="relative flex-grow flex flex-col px-2">
                    <p class="flex-none flex text-lg overflow-hidden">
                      <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                      <span class="w-1/3 mr-4">FaceBook Post</span>
                    </p>
                    <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                    <div class="flex-none flex">
                      <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">24</span>
                      <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">1</span>
                      <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <div class="flex-grow text-right text-gray-500">
                        <span>2024/12/04</span>
                      </div>
                    </div>
                  </div>
                  <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                </div>
              </div>
              <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                <div class="relative flex justify-between p-1">
                  <div class="md:flex-shrink-0">
                    <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                  </div>
                  <div class="relative flex-grow flex flex-col px-2">
                    <p class="flex-none flex text-lg overflow-hidden">
                      <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                      <span class="w-1/3 mr-4">FaceBook Post</span>
                    </p>
                    <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                    <div class="flex-none flex">
                      <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">24</span>
                      <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">1</span>
                      <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <div class="flex-grow text-right text-gray-500">
                        <span>2024/12/04</span>
                      </div>
                    </div>
                  </div>
                  <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                </div>
              </div>
              <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                <div class="relative flex justify-between p-1">
                  <div class="md:flex-shrink-0">
                    <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                  </div>
                  <div class="relative flex-grow flex flex-col px-2">
                    <p class="flex-none flex text-lg overflow-hidden">
                      <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                      <span class="w-1/3 mr-4">FaceBook Post</span>
                    </p>
                    <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                    <div class="flex-none flex">
                      <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">24</span>
                      <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">1</span>
                      <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <div class="flex-grow text-right text-gray-500">
                        <span>2024/12/04</span>
                      </div>
                    </div>
                  </div>
                  <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                </div>
              </div>
              <div v-tippy="tooltipOptions" class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group">
                <div class="relative flex justify-between p-1">
                  <div class="md:flex-shrink-0">
                    <img class="h-24 w-24 rounded-xl object-cover" src="https://scontent-nrt1-1.xx.fbcdn.net/v/t15.5256-10/469018299_2099756487132679_8282074920297271073_n.jpg?stp=dst-jpg_s130x130_tt6&amp;_nc_cat=109&amp;ccb=1-7&amp;_nc_sid=7965db&amp;_nc_ohc=W7OCKGYCh54Q7kNvwHym8RL&amp;_nc_oc=AdnEUR9t2-o4WBRnenA3fH7tg-I-LklVkhqGRRvMTkHGCk8mxL1ZPonHGDzn6JEoRw4&amp;_nc_zt=23&amp;_nc_ht=scontent-nrt1-1.xx&amp;edm=AJfPMC4EAAAA&amp;_nc_gid=FALIYAFCBVtgGnPYOPpL7A&amp;oh=00_AfMZp-Q1oPVRVsgHbvTIFLyoNVbG0Xb2WDgTT56Vh80hGw&amp;oe=68484BB9">
                  </div>
                  <div class="relative flex-grow flex flex-col px-2">
                    <p class="flex-none flex text-lg overflow-hidden">
                      <span style="width: 70%;">AI 加漏斗 讓投放更高效 更省時！...</span>
                      <span class="w-1/3 mr-4">FaceBook Post</span>
                    </p>
                    <p class="flex-grow text-gray-500 overflow-hidden">1108961467897381</p>
                    <div class="flex-none flex">
                      <img src="/img/great.a251d02f.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">24</span>
                      <img src="/img/heart.8fdcbfc4.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">1</span>
                      <img src="/img/smile.65142fbd.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/cry.6e25808e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/shock.bdb7c0e5.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <img src="/img/angry.1c0ad48e.svg" class="w-6 h-6">
                      <span class="pl-1 pr-4">0</span>
                      <div class="flex-grow text-right text-gray-500">
                        <span>2024/12/04</span>
                      </div>
                    </div>
                  </div>
                  <i class="absolute top-2 right-2 pi pi-times cursor-pointer"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex space-x-4 border-t pt-4">
          <div class="mb-4">
            <p class="text-lg font-bold text-primary mb-2">概況描述</p>
            <p class="text-gray-500">目前廣告尚處於投遞初期的學習期階段，系統正針對不同受眾群與版位進行 A/B 測試，以找出最佳投遞組合。初步數據顯示，行動裝置用戶點擊率較高，但轉換率尚未穩定。現階段平均 CPC 為 NT$8.1，CPA 則約落在 NT$240，仍有優化空間。後續系統將逐步排除低互動的廣告組合，並集中資源於高表現版位。投遞策略將轉向以轉換優化（oCPA）為主，逐步壓低 CPA 並提升 ROAS（廣告投資報酬率）。</p>
          </div>
        </div>

        <div class="flex space-x-4 border-t pt-4">
          <div class="mb-4">
            <p class="text-lg font-bold text-primary mb-2">建議策略</p>
            <div class="space-y-2 text-gray-500">
              <label class="flex items-center space-x-2">
                <input type="radio" name="strategy" value="keep" class="accent-primary" checked>
                <span>維持目前策略</span>
              </label>
              <label class="flex items-center space-x-2">
                <input type="radio" name="strategy" value="clicks" class="accent-primary">
                <span>優化點擊率</span>
              </label>
              <label class="flex items-center space-x-2">
                <input type="radio" name="strategy" value="reach" class="accent-primary">
                <span>提高觸及人數</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <button type="submit" class="bg-green-500 text-white px-2 py-1 rounded">
          確定
        </button>
        <button @click="showDialog = false" class="bg-gray-200 text-gray-700 px-2 py-1 rounded ml-1">
          關閉
        </button>
      </template>
    </Dialog>

  </div>
</template>

<script>

import OverlayPanel from 'primevue/overlaypanel'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import ActionIcon from './ActionIcon.vue';
import { FilterMatchMode, FilterOperator } from "primevue/api"
import PanelChart from '@/components/List/PanelChart.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import CircleProgress from "vue3-circle-progress";
import Dialog from '@/components/Dialog.vue'
import SettingItem from '@/components/SettingItem.vue';
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'ListDataTable',
  components: {
    DataTable,
    Column,
    InputText,
    ActionIcon,
    OverlayPanel,
    PanelChart,
    Loading,
    CircleProgress,
    Dialog,
    SettingItem
  },
  props: {
    showTable: {
      type: Boolean
    },
    viewDatalist: {
      type: Object,
      default: () => []
    },
    selecdedCurrency: {
      type: String
    },
    fromAccountSelect: {
      type: String
    },
    parentMemberInfo: {
      type: Object,
      default: () => []
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      fin: false,
      chartCampaignId: null,
      chartCampaignAdaccountId: null,
      allPageLoading: false,
      releaseType: true,
      style: 'z-index: -1;',
      releaseText: '發佈中...',
      releasePercent: 5,
      label:[],
      // tableData: [
      //   {
      //     since: "2021-03-11",
      //     title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
      //     until: "2021-03-11",
      //     since_value: 3.0364372469636,
      //     until_value: 0.95785440613027,
      //     since_index: 6,
      //     until_index: 9,
      //     data_key: "data1"
      //   },
      //   {
      //     since: "2021-05-04",
      //     title: "網頁轉換表現不佳，建議優化網頁內容或是增強與廣告關聯性",
      //     until: "2021-05-07",
      //     since_value: 3.0364372469636,
      //     until_value: 0.95785440613027,
      //     since_index: 6,
      //     until_index: 9,
      //     data_key: "data1"
      //   }
      // ],
      tableData: [],
      // lineStylesData: {
      //   datasets: [
      //     {
      //       data: [
      //         {
      //           x: new Date('2021/02/15'),
      //           y: 11
      //         },
      //         {
      //           x: new Date('2021/03/15'),
      //           y: 30
      //         },
      //         {
      //           x: new Date('2021/04/04'),
      //           y: 46
      //         },
      //         {
      //           x: new Date('2021/05/04'),
      //           y: 66
      //         },
      //         {
      //           x: new Date('2021/07/11'),
      //           y: 82
      //         }
      //       ],
      //       //pointRadius: 0,
      //       fill: true,
      //       borderColor: '#FADB76',
      //       backgroundColor: 'rgba(250, 219, 118, 0.3)',
      //       tension: .4,
      //     },
      //     {
      //       data: [
      //         {
      //           x: new Date('2021/02/15'),
      //           y: 22
      //         },
      //         {
      //           x: new Date('2021/03/15'),
      //           y: 13
      //         },
      //         {
      //           x: new Date('2021/04/04'),
      //           y: 54
      //         },
      //         {
      //           x: new Date('2021/05/04'),
      //           y: 76
      //         },
      //         {
      //           x: new Date('2021/07/11'),
      //           y: 102
      //         }
      //       ],
      //       //pointRadius: 0,
      //       fill: true,
      //       borderColor: '#72B6F4',
      //       backgroundColor: 'rgba(114, 182, 244, 0.2)',
      //       tension: .4,
      //     },
      //   ],
      // },
      lineStylesData: [],
      records: [],
      loading: false,
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        },
        campaign_name: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        status: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        report: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        active: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        updatedDate: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }]
        },
        pageInfo: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        }
      },
      showDialog: false,
      form: {},
      tooltipOptions: {
        allowHTML: true,
        interactive: true,
        placement: 'right',
        maxWidth: 'none',
        content:
          '<div style="width: 400px; height: 530px;"><iframe src="https://business.facebook.com/ads/api/preview_iframe.php?d=AQKqGle1IopBPYjTUbuc-NXcHpVc0Ep37lTOpKsajeAcux8MJ2A3Bv03rwemD6A81nJ50O3Qx-uAM5FbNvfP9niH_MiAN6DKKwsQlwxRi6piP-qhpVC6SOtEkUsSN25yPam3mGMwvUV_Oy8WeHGYc6NcrbucfCFSiNax9R8bJBRJKnqKiSgu8OgAqO62tSwhacDJEt3RMzdmuNWg7xQlydhmqJ9pR0vuuT65bzcSc52J7XTk9Lh3_mAjFC1_GaklbvHTmqZ1Ru6IjaAipUAapQP-WezuLRaqSeNTPByw6492nuExK1rNdVjmDSywenLUcXktlXDnWqHvmc7PN3RXLlifjcbl9j__PTenAYSGvOplCsxsC6qPs1AnRS8cBnV1jXZDfWABRCaHxQIjarOxZWv1NRc2CgW3u_fZP4dcaEey2ARIL4dS2_vcJsMqistkFdFIulZkQHcAAmdWragX09q9jiKfiy9DkuVQeEJPNLIsMTcWOkH6WNrsbq4oiUvGf8Mjbs4fA2huoEXaBMt3KJEU-mOCwtHKkyMleymo3bqm-xY_uQ_MlVcZGfCWk_8IRs9D1oVXNa4DtCHe2I4IPz1OSl-9GkeEnuFrsXkjh7rvaD38K3lo1yticRG0hMV-oSOw8s4mIJ74CjDSre1WBGSJ&amp;t=AQK04bxO27Kl5Pi7j-I" width="100%" height="520" scrolling="yes" style="border: none;"></iframe></div>',
        theme: 'light-border',
        offset: [0, 10], // optional: x, y offset
      },
    };
  },
  created() {
    // this.releaseType = false;
    // axios
    //   .post('https://test.autoturn.net/inside/api/campaign_list.php', Qs.stringify({
    //     s_code: this.$route.params.id,
    //     adaccount_id: this.$route.params.adaccount_id,
    //   }))
    //   .then((response) => {
    //     console.log(response.data);
    //     if(response.data.status == 'success'){
    //       this.records = response.data.return_data
    //     }
    //   });
    // console.log('created');
    // var bar5 = new ldBar("#releaseFill");
    // var bar6 = new ldBar(".test1209");
    // bar6.set(20);
  },
  watch:{
    viewDatalist(v){
      // console.log('table viewDatalist');
      // console.log(v);

      this.records = v
    }
  },
  methods: {
    handleSubmit() {
      // 模擬送出表單
      console.log('表單資料：', this.form)

      // 可加上 ajax 請求或 emit 到父層

      // 關閉視窗
      this.showDialog = false

      // 重置資料（可選）
      this.form.name = ''
      this.form.email = ''
    },
    handleClickOpen(e, id, status, adaccountid) {
      // console.log(e+':'+id+status);

      if(status == '執行中' || status == '执行中' || status == 'in execution' || status == '已暫停' || status == '已暂停' || status == 'Paused' || status == '已結束' || status == 'over'){
        this.toggle(e)

        axios
          .post('https://test.autoturn.net/inside/api/campaign_item_chart.php', Qs.stringify({
            s_code: this.$route.params.id,
            id: id,
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'success'){
              // this.records = response.data.return_data

              this.label = response.data.chart_panel
              this.tableData = response.data.info_data
              this.lineStylesData = response.data.return_data

              this.chartCampaignId = id
              this.chartCampaignAdaccountId = adaccountid

              // console.log('tableData');
              // console.log(this.tableData);
              // console.log('lineStylesData');
              // console.log(this.lineStylesData);

              this.fin = true
            }
          });
      }
    },
    toggle(event) {
      // console.log('toggle:'+event)
      this.$refs.previewPanel.toggle(event)

      if(this.fin == true){
        this.fin = false
      }
    },
    campaignActive(id, type, daily_budget, budget_increase, name, adaccount_id, total_budget, Target_AD, Target_CT, sub_campaigns){
      console.log('id:'+id+' | type:'+type+' | daily_budget:'+daily_budget+' | budget_increase:'+budget_increase+' | name:'+name+' | adaccount_id:'+adaccount_id+' | total_budget:'+total_budget+' | Target_AD:'+Target_AD);

      console.log('facebook selecdedCurrency:'+this.selecdedCurrency);

      let currency = this.selecdedCurrency;
      let member_hash = this.$route.params.id;

      console.log('fromAccountSelect');
      console.log(this.fromAccountSelect);

      axios
        .post('https://test.autoturn.net/inside/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: type,
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  // Swal.fire('Saved!', '', 'success')
                  this.allPageLoading = true
                  window.location.href = "https://dev-private.autoturn.net/f/"+member_hash;
                } else if (result.isDenied) {
                  // Swal.fire('Changes are not saved', '', 'info')
                  this.allPageLoading = true
                  window.location.href = "https://dev-private.autoturn.net/f/"+member_hash;
                }
              })
            } else {
              Swal.fire(
                        this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['error']['swal_title'],
                        caResponse.data.info,
                        caResponse.data.status
                      )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              if(type == 'edit'){
                if(this.fromAccountSelect == 'facebook'){
                  window.location.href = "https://dev-private.autoturn.net/target-event/f/"+member_hash+"/"+adaccount_id+"/"+id;
                } else {
                  window.location.href = "https://dev-private.autoturn.net/event-tiktok/t/"+member_hash+"/"+adaccount_id+"/"+id;
                }
              }

              if(type == 'copy'){
                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['swal_title']+"「"+name+"」",
                  html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['swal_text'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(this.$route.params.id);
                    axios
                      .post('https://test.autoturn.net/inside/api/target/campaign/campaign_copy.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        // this.$swal(caResponse.data.info);
                        Swal.fire({
                          icon: caResponse.data.status,
                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['swal_title']+"「"+name+"」",
                          text: caResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['copy']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true
                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true
                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                          }
                        })
                      });
                  }
                })
              }

              if(type == 'chart'){
                window.location.href = "https://dev-private.autoturn.net/report/f/"+member_hash+"/"+adaccount_id+"/"+id;
              }

              if(type == 'pause'){
                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['swal_title']+"「"+name+"」",
                  html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['swal_text'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(this.$route.params.id);
                    axios
                      .post('https://test.autoturn.net/inside/api/target/campaign/campaign_stop.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        // this.$swal(caResponse.data.info);
                        Swal.fire({
                          icon: caResponse.data.status,
                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['swal_title']+"「"+name+"」",
                          text: caResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['pause']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true
                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true
                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                          }
                        })
                      });
                  }
                })
              }

              if(type == 'delete'){
                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['swal_title']+"「"+name+"」",
                  html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['swal_text'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(this.$route.params.id);
                    axios
                      .post('https://test.autoturn.net/inside/api/target/campaign/campaign_delete.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        // this.$swal(caResponse.data.info);
                        Swal.fire({
                          icon: caResponse.data.status,
                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['swal_title']+"「"+name+"」",
                          text: caResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['delete']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true
                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true
                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                          }
                        })
                      });
                  }
                })
              }

              if(type == 'play'){
                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['swal_title']+"「"+name+"」",
                  html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['swal_text'],
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log(this.$route.params.id);
                    axios
                      .post('https://test.autoturn.net/inside/api/campaign_restart.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        // this.$swal(caResponse.data.info);
                        Swal.fire({
                          icon: caResponse.data.status,
                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['swal_title']+"「"+name+"」",
                          text: caResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['play']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            this.allPageLoading = true
                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            this.allPageLoading = true
                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                          }
                        })
                      });
                  }
                })
              }

              if(type == 'browse'){
                window.location.href = "https://dev-private.autoturn.net/target-event-browse/f/"+member_hash+"/"+adaccount_id+"/"+id;
              }

              if(type == 'release'){
                let addition_text = '（'+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['addition_text']+'：<span style="color:red; font-weight:bold;">'+budget_increase+'%</span>）';
                if(Target_AD == true){
                  addition_text = '';
                }
                let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(budget_increase/100)));
                let campaignInfo = '';//this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_total_budget_a']+"<br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_total_budget_c']+"</span>"+addition_text + "<br/><br/>";
                // if(total_budget != 0){
                //   two_week_budget = total_budget;
                //   campaignInfo = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_not_total_budget_a']+"<br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_not_total_budget_c']+"</span>"+addition_text + "<br/><br/>";
                // }

                console.log('this.parentMemberInfo');
                console.log(this.parentMemberInfo);

                if(this.parentMemberInfo.source == 6 && (this.parentMemberInfo.plan_id == 1 || this.parentMemberInfo.status == 's')){
                  Swal.fire({
                    icon: 'warning',
                    title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['class_check_release_permissions']['swal_title'],
                    text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['class_check_release_permissions']['swal_text'],
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText:this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['class_check_release_permissions']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {

                  })
                } else {
                  let _tableContent = campaignInfo+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_a']+"<span style='color:red;'>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_b']+"</span>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_text_c'];

                  Swal.fire({
                    title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['swal_title']+"「"+name+"」",
                    html: _tableContent,
                    icon: 'warning',
                    showCancelButton: true,
                    // width: 'auto', // 可選：根據內容自動調整寬度
                    // padding: '1em',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['yes_button'],
                    cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['no_button'],
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // console.log('this.$route.params.id:');
                      // console.log(this.$route.params.id);
                      // console.log('id:');
                      // console.log(id);

                      this.releaseType = true
                      this.style = 'z-index:100;';
                      this.releasePercent = 5;
                      let status = 1;
                      let num = 0;
                      var bar5 = new ldBar("#releaseFill");
                      bar5.set(this.releasePercent);

                      axios
                        .post('https://test.autoturn.net/inside/api/target/campaign/campaign_release.php', Qs.stringify({
                          s_code: member_hash,
                          campaign_id: id,
                        }))
                        .then((caResponse) => {
                          // console.log('caResponse:'+caResponse.data.return_data);
                          if(caResponse.data.status == 'success'){
                            console.log('開始進度條');
                            //進行進度條
                            console.log('發佈莞成，開始跑進度條');
                            let taskId = caResponse.data.id;

                            setInterval( () => {
                              num++;
                              if(num < 1200){
                                // console.log('num:'+num);
                                // console.log(this.releaseType);

                                if(this.releaseType == true){
                                  axios
                                    .post('https://test.autoturn.net/inside/api/target/campaign/campaign_task.php', Qs.stringify({
                                      s_code: member_hash,
                                      id: taskId,
                                    }))
                                    .then((csResponse) => {
                                      // console.log('csResponse:'+csResponse.data.return_data);
                                      //進行進度條
                                      if(status == 1){
                                        if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                          this.releaseType = false
                                          status = 0;

                                          let _tableContent = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_failure']['swal_html_a']+csResponse.data.return_data.current+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_failure']['swal_html_b'];
                                          let useTimer = 5000;

                                          if(Target_CT == '1'){
                                            _tableContent = '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+'<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                                                    <div style="display: flex; width: 100%;">\
                                                                      <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段名稱</div>\
                                                                      <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">發布結果</div>\
                                                                    </div>';

                                            for(let j = 0; j < sub_campaigns.length; j++){
                                              let _methodName = sub_campaigns[j].subset_method;
                                              let _releaseContent = csResponse.data.sub_campaigns[sub_campaigns[j].sr_i].current;
                                              let stageIndex = j;
                                              let stageTitle = _methodName;
                                              if(sub_campaigns[0].method != 'META_TEST'){
                                                stageIndex = j + parseInt(1);
                                                stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                              } else {
                                                if(j != 0){
                                                  stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                }
                                              }

                                              _tableContent += '<div style="display: flex; width: 100%;">\
                                                                  <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+stageTitle+'</div>\
                                                                  <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_releaseContent+'</div>\
                                                                </div>';
                                            }

                                            _tableContent += '</div>';
                                            useTimer = 60000;
                                          }

                                          Swal.fire({
                                            icon: 'error',
                                            title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_failure']['swal_title'],
                                            html: _tableContent,
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            width: 'auto',
                                            padding: '1em',
                                            confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_failure']['confirm_button'],
                                            timer: useTimer
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                          status = 0;

                                          let postData = {adaccount_id: this.$route.params.adaccount_id};
                                          let codeHash = ['de', 'di']

                                          const data = new URLSearchParams();
                                          data.append('s_code', this.$route.params.id);
                                          data.append('post_data', JSON.stringify(postData));
                                          data.append('code_hash', JSON.stringify(codeHash));
                                          data.append('update_type', true);

                                          // 發送請求
                                          navigator.sendBeacon(
                                            'https://test.autoturn.net/inside/api/update_cache.php',
                                            data
                                          );

                                          axios
                                            .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                              s_code: member_hash,
                                              id: id,
                                            }))
                                            .then((response) => {
                                              axios
                                                .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+id)
                                                .then((csResponse) => {
                                                  this.releaseType = false

                                                  Swal.fire({
                                                    icon: 'success',
                                                    title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_success']['swal_title'],
                                                    text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_success']['swal_html'],
                                                    showDenyButton: false,
                                                    showCancelButton: false,
                                                    confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['info_state_success']['confirm_button'],
                                                    timer: 5000
                                                    // denyButtonText: `Don't save`,
                                                  }).then((result) => {
                                                    /* Read more about isConfirmed, isDenied below */
                                                    if (result.isConfirmed) {
                                                      // Swal.fire('Saved!', '', 'success')
                                                      this.allPageLoading = true
                                                      window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                    } else if (result.isDenied) {
                                                      // Swal.fire('Changes are not saved', '', 'info')
                                                      this.allPageLoading = true
                                                      window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                    }

                                                    if (result.dismiss === Swal.DismissReason.timer) {
                                                      this.allPageLoading = true
                                                      window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                    }
                                                  })
                                                });
                                            });
                                        } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                          this.releaseType = false
                                          status = 0;

                                          let _tableContent = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_a']+csResponse.data.return_data.current+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_b'];
                                          let useTimer = 5000;

                                          if(Target_CT == '1'){
                                            _tableContent = '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+'<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                                                    <div style="display: flex; width: 100%;">\
                                                                      <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段名稱</div>\
                                                                      <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">發布結果</div>\
                                                                    </div>';

                                            for(let j = 0; j < sub_campaigns.length; j++){
                                              let _methodName = sub_campaigns[j].subset_method;
                                              let _releaseContent = csResponse.data.sub_campaigns[sub_campaigns[j].sr_i].current;
                                              let stageIndex = j;
                                              let stageTitle = _methodName;
                                              if(sub_campaigns[0].method != 'META_TEST'){
                                                stageIndex = j + parseInt(1);
                                                stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                              } else {
                                                if(j != 0){
                                                  stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                                }
                                              }

                                              _tableContent += '<div style="display: flex; width: 100%;">\
                                                                  <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+stageTitle+'</div>\
                                                                  <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_releaseContent+'</div>\
                                                                </div>';
                                            }

                                            _tableContent += '</div>';
                                            useTimer = 60000;
                                          }

                                          Swal.fire({
                                            icon: 'error',
                                            title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_title'],
                                            html: _tableContent,
                                            showDenyButton: false,
                                            showCancelButton: false,
                                            width: 'auto',
                                            padding: '1em',
                                            confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['confirm_button'],
                                            timer: useTimer
                                            // denyButtonText: `Don't save`,
                                          }).then((result) => {
                                            /* Read more about isConfirmed, isDenied below */
                                            if (result.isConfirmed) {
                                              // Swal.fire('Saved!', '', 'success')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            } else if (result.isDenied) {
                                              // Swal.fire('Changes are not saved', '', 'info')
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            }

                                            if (result.dismiss === Swal.DismissReason.timer) {
                                              this.allPageLoading = true
                                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                            }
                                          })
                                        } else {
                                          this.releaseText = csResponse.data.return_data.info_text
                                          this.releasePercent = csResponse.data.return_data.pct

                                          bar5.set(this.releasePercent);
                                          // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                          // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                          // console.log('this.releaseText:'+this.releaseText);
                                          // console.log('this.releasePercent:'+this.releasePercent);

                                          if(csResponse.data.return_data.pct == 100){
                                            this.releaseType = false
                                            this.style = 'z-index:-1;';
                                            bar5.set(0);
                                            status = 0;
                                          }
                                        }
                                      }
                                    });
                                }
                              } else {
                                Swal.fire({
                                  icon: 'warning',
                                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['else']['swal_title'],
                                  text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['else']['swal_html'],
                                  showDenyButton: false,
                                  showCancelButton: false,
                                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['else']['confirm_button'],
                                  timer: 1000
                                  // denyButtonText: `Don't save`,
                                }).then((result) => {
                                  /* Read more about isConfirmed, isDenied below */
                                  if (result.isConfirmed) {
                                    // Swal.fire('Saved!', '', 'success')
                                    this.allPageLoading = true
                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                  } else if (result.isDenied) {
                                    // Swal.fire('Changes are not saved', '', 'info')
                                    this.allPageLoading = true
                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                  }

                                  if (result.dismiss === Swal.DismissReason.timer) {
                                    this.allPageLoading = true
                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                  }
                                })
                              }
                            }, 3000);
                          } else {
                            Swal.fire({
                              icon: 'error',
                              title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_title'],
                              text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_a']+caResponse.data.info+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_b'],
                              showDenyButton: false,
                              showCancelButton: false,
                              confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['confirm_button'],
                              timer: 5000
                              // denyButtonText: `Don't save`,
                            }).then((result) => {
                              /* Read more about isConfirmed, isDenied below */
                              if (result.isConfirmed) {
                                // Swal.fire('Saved!', '', 'success')
                                this.allPageLoading = true
                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                              } else if (result.isDenied) {
                                // Swal.fire('Changes are not saved', '', 'info')
                                this.allPageLoading = true
                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                              }

                              if (result.dismiss === Swal.DismissReason.timer) {
                                this.allPageLoading = true
                                window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                              }
                            })
                          }
                        });
                    }
                  })
                }

              }

              if(type == 'suggest'){
                this.showDialog = true;
              }
            });
          }

          if(caResponse.data.status == 'success'){
            if(type == 'edit'){
              if(this.fromAccountSelect == 'facebook'){
                window.location.href = "https://dev-private.autoturn.net/target-event/f/"+member_hash+"/"+adaccount_id+"/"+id;
              } else {
                window.location.href = "https://dev-private.autoturn.net/event-tiktok/t/"+member_hash+"/"+adaccount_id+"/"+id;
              }
            }

            if(type == 'copy'){
              Swal.fire({
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['swal_title']+"「"+name+"」",
                html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['swal_text'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['yes_button'],
                cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  axios
                    .post('https://test.autoturn.net/inside/api/target/campaign/campaign_copy.php', Qs.stringify({
                      s_code: member_hash,
                      campaign_id: id,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      // this.$swal(caResponse.data.info);
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['swal_title']+"「"+name+"」",
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['copy']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    });
                }
              })
            }

            if(type == 'chart'){
              window.location.href = "https://dev-private.autoturn.net/report/f/"+member_hash+"/"+adaccount_id+"/"+id;
            }

            if(type == 'pause'){
              Swal.fire({
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['swal_title']+"「"+name+"」",
                html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['swal_text'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['yes_button'],
                cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  axios
                    .post('https://test.autoturn.net/inside/api/target/campaign/campaign_stop.php', Qs.stringify({
                      s_code: member_hash,
                      campaign_id: id,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      // this.$swal(caResponse.data.info);
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['swal_title']+"「"+name+"」",
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['pause']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    });
                }
              })
            }

            if(type == 'delete'){
              Swal.fire({
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['swal_title']+"「"+name+"」",
                html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['swal_text'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['yes_button'],
                cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  axios
                    .post('https://test.autoturn.net/inside/api/target/campaign/campaign_delete.php', Qs.stringify({
                      s_code: member_hash,
                      campaign_id: id,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      // this.$swal(caResponse.data.info);
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['swal_title']+"「"+name+"」",
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['delete']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    });
                }
              })
            }

            if(type == 'play'){
              Swal.fire({
                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['swal_title']+"「"+name+"」",
                html: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['swal_text'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['yes_button'],
                cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  axios
                    .post('https://test.autoturn.net/inside/api/campaign_restart.php', Qs.stringify({
                      s_code: member_hash,
                      campaign_id: id,
                    }))
                    .then((caResponse) => {
                      // console.log('caResponse:'+caResponse.data.return_data);
                      // this.$swal(caResponse.data.info);
                      Swal.fire({
                        icon: caResponse.data.status,
                        title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['swal_title']+"「"+name+"」",
                        text: caResponse.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['play']['confirm_button'],
                        // denyButtonText: `Don't save`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          // Swal.fire('Saved!', '', 'success')
                          this.allPageLoading = true
                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                        }
                      })
                    });
                }
              })
            }

            if(type == 'browse'){
              window.location.href = "https://dev-private.autoturn.net/target-event-browse/f/"+member_hash+"/"+adaccount_id+"/"+id;
            }

            if(type == 'release'){
              let addition_text = '（'+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['addition_text']+'：<span style="color:red; font-weight:bold;">'+budget_increase+'%</span>）';
              if(Target_AD == true){
                addition_text = '';
              }
              let two_week_budget = Math.round((daily_budget*7)+(daily_budget*7)+(daily_budget*7*(budget_increase/100)));
              let campaignInfo = '';//this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_total_budget_a']+"<br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_total_budget_c']+"</span>"+addition_text + "<br/><br/>";
              // if(total_budget != 0){
              //   two_week_budget = total_budget;
              //   campaignInfo = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_not_total_budget_a']+"<br/>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_not_total_budget_b']+"<span style='color:red;font-weight:bold;'>（"+currency+"）"+two_week_budget+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_not_total_budget_c']+"</span>"+addition_text + "<br/><br/>";
              // }

              console.log('this.parentMemberInfo');
              console.log(this.parentMemberInfo);

              if(this.parentMemberInfo.source == 6 && (this.parentMemberInfo.plan_id == 1 || this.parentMemberInfo.status == 's')){
                Swal.fire({
                  icon: 'warning',
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['class_check_release_permissions']['swal_title'],
                  text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['class_check_release_permissions']['swal_text'],
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText:this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['class_check_release_permissions']['confirm_button'],
                  // denyButtonText: `Don't save`,
                }).then((result) => {

                })
              } else {
                let _tableContent = campaignInfo+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_a']+"<span style='color:red;'>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_b']+"</span>"+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_text_c'];

                Swal.fire({
                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['swal_title']+"「"+name+"」",
                  html: _tableContent,
                  icon: 'warning',
                  showCancelButton: true,
                  // width: 'auto', // 可選：根據內容自動調整寬度
                  // padding: '1em',
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['yes_button'],
                  cancelButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['no_button'],
                }).then((result) => {
                  if (result.isConfirmed) {
                    // console.log('this.$route.params.id:');
                    // console.log(this.$route.params.id);
                    // console.log('id:');
                    // console.log(id);

                    this.releaseType = true
                    this.style = 'z-index:100;';
                    this.releasePercent = 5;
                    let status = 1;
                    let num = 0;
                    var bar5 = new ldBar("#releaseFill");
                    bar5.set(this.releasePercent);

                    axios
                      .post('https://test.autoturn.net/inside/api/target/campaign/campaign_release.php', Qs.stringify({
                        s_code: member_hash,
                        campaign_id: id,
                      }))
                      .then((caResponse) => {
                        // console.log('caResponse:'+caResponse.data.return_data);
                        if(caResponse.data.status == 'success'){
                          console.log('進度條');
                          //進行進度條
                          console.log('發佈莞成，開始跑進度條');
                          let taskId = caResponse.data.id;

                          setInterval( () => {
                            num++;
                            if(num < 1200){
                              // console.log('num:'+num);
                              // console.log(this.releaseType);

                              if(this.releaseType == true){
                                axios
                                  .post('https://test.autoturn.net/inside/api/target/campaign/campaign_task.php', Qs.stringify({
                                      s_code: member_hash,
                                      id: taskId,
                                    }))
                                  .then((csResponse) => {
                                    // console.log('csResponse:'+csResponse.data.return_data);
                                    //進行進度條
                                    if(status == 1){
                                      if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'FAILURE'){
                                        this.releaseType = false
                                        status = 0;

                                        let _tableContent = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_failure']['swal_html_a']+csResponse.data.return_data.current+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_failure']['swal_html_b'];
                                        let useTimer = 5000;

                                        if(Target_CT == '1'){
                                          _tableContent = '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+'<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                                                  <div style="display: flex; width: 100%;">\
                                                                    <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段名稱</div>\
                                                                    <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">發布結果</div>\
                                                                  </div>';

                                          for(let j = 0; j < sub_campaigns.length; j++){
                                            let _methodName = sub_campaigns[j].subset_method;
                                            let _releaseContent = csResponse.data.sub_campaigns[sub_campaigns[j].sr_i].current;
                                            let stageIndex = j;
                                            let stageTitle = _methodName;
                                            if(sub_campaigns[0].method != 'META_TEST'){
                                              stageIndex = j + parseInt(1);
                                              stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                            } else {
                                              if(j != 0){
                                                stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                              }
                                            }

                                            _tableContent += '<div style="display: flex; width: 100%;">\
                                                                <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+stageTitle+'</div>\
                                                                <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_releaseContent+'</div>\
                                                              </div>';
                                          }

                                          _tableContent += '</div>';
                                          useTimer = 60000;
                                        }

                                        Swal.fire({
                                          icon: 'error',
                                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_failure']['swal_title'],
                                          html: _tableContent,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          width: 'auto',
                                          padding: '1em',
                                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_failure']['confirm_button'],
                                          timer: useTimer
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          let info_text = csResponse.data.return_data.current;
                                          let tosStatus = info_text.includes("/leadgen/tos");

                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      } else if(csResponse.data.return_data.state == 'SUCCESS' && csResponse.data.return_data.info_state == 'SUCCESS'){
                                        status = 0;

                                        let postData = {adaccount_id: this.$route.params.adaccount_id};
                                        let codeHash = ['de', 'di']

                                        const data = new URLSearchParams();
                                        data.append('s_code', this.$route.params.id);
                                        data.append('post_data', JSON.stringify(postData));
                                        data.append('code_hash', JSON.stringify(codeHash));
                                        data.append('update_type', true);

                                        // 發送請求
                                        navigator.sendBeacon(
                                          'https://test.autoturn.net/inside/api/update_cache.php',
                                          data
                                        );

                                        axios
                                          .post('https://test.autoturn.net/inside/api/data/campaign_creative_optimize_update.php', Qs.stringify({
                                            s_code: member_hash,
                                            id: id,
                                          }))
                                          .then((response) => {
                                            axios
                                              .get('https://test.autoturn.net/inside/udnapi/public/send_notice_email.php?s_code='+member_hash+'&form=release&sr_i='+id)
                                              .then((csResponse) => {
                                                this.releaseType = false

                                                Swal.fire({
                                                  icon: 'success',
                                                  title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_success']['swal_title'],
                                                  text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_success']['swal_html'],
                                                  showDenyButton: false,
                                                  showCancelButton: false,
                                                  confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['info_state_success']['confirm_button'],
                                                  timer: 5000
                                                  // denyButtonText: `Don't save`,
                                                }).then((result) => {
                                                  /* Read more about isConfirmed, isDenied below */
                                                  if (result.isConfirmed) {
                                                    // Swal.fire('Saved!', '', 'success')
                                                    this.allPageLoading = true
                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                  } else if (result.isDenied) {
                                                    // Swal.fire('Changes are not saved', '', 'info')
                                                    this.allPageLoading = true
                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                  }

                                                  if (result.dismiss === Swal.DismissReason.timer) {
                                                    this.allPageLoading = true
                                                    window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                                  }
                                                })
                                              });
                                          });
                                      } else if(csResponse.data.return_data.state == 'FAILURE' && csResponse.data.return_data.info_state == 'FAILURE'){
                                        this.releaseType = false
                                        status = 0;

                                        let _tableContent = this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['state_failure']['swal_html_a']+csResponse.data.return_data.current+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['state_failure']['swal_html_b'];
                                        let useTimer = 5000;

                                        if(Target_CT == '1'){
                                          _tableContent = '發布失敗，請參考下列各階段的發布結果，來進行調整：<br/>'+'<div style="display: flex; flex-wrap: wrap; width: 600px; border: 1px solid #ccc;">\
                                                                  <div style="display: flex; width: 100%;">\
                                                                    <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">階段名稱</div>\
                                                                    <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px; background-color: #CBD5E1;">發布結果</div>\
                                                                  </div>';

                                          for(let j = 0; j < sub_campaigns.length; j++){
                                            let _methodName = sub_campaigns[j].subset_method;
                                            let _releaseContent = csResponse.data.sub_campaigns[sub_campaigns[j].sr_i].current;
                                            let stageIndex = j;
                                            let stageTitle = _methodName;
                                            if(sub_campaigns[0].method != 'META_TEST'){
                                              stageIndex = j + parseInt(1);
                                              stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                            } else {
                                              if(j != 0){
                                                stageTitle = '階段 '+stageIndex+'：'+_methodName;
                                              }
                                            }

                                            _tableContent += '<div style="display: flex; width: 100%;">\
                                                                <div style="width: 33.33%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+stageTitle+'</div>\
                                                                <div style="width: 66.67%; height: auto; border: 1px solid #ccc; display: flex; align-items: center; justify-content: center; box-sizing: border-box; padding: 18px 4px;">'+_releaseContent+'</div>\
                                                              </div>';
                                          }

                                          _tableContent += '</div>';
                                          useTimer = 60000;
                                        }

                                        Swal.fire({
                                          icon: 'error',
                                          title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['state_failure']['swal_title'],
                                          html: _tableContent,
                                          showDenyButton: false,
                                          showCancelButton: false,
                                          width: 'auto',
                                          padding: '1em',
                                          confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['state_failure']['confirm_button'],
                                          timer: useTimer
                                          // denyButtonText: `Don't save`,
                                        }).then((result) => {
                                          /* Read more about isConfirmed, isDenied below */
                                          let info_text = csResponse.data.return_data.current;
                                          let tosStatus = info_text.includes("/leadgen/tos");

                                          if (result.isConfirmed) {
                                            // Swal.fire('Saved!', '', 'success')
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          } else if (result.isDenied) {
                                            // Swal.fire('Changes are not saved', '', 'info')
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          }

                                          if (result.dismiss === Swal.DismissReason.timer) {
                                            this.allPageLoading = true
                                            if(tosStatus == true){
                                              window.open('https://www.facebook.com/ads/leadgen/tos', '', 'height=768,width=1024');
                                            }
                                            window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                          }
                                        })
                                      } else {
                                        this.releaseText = csResponse.data.return_data.current
                                        this.releasePercent = csResponse.data.return_data.pct

                                        bar5.set(this.releasePercent);
                                        // console.log('csResponse.data.return_data.info_text:'+csResponse.data.return_data.info_text);
                                        // console.log('csResponse.data.return_data.info_pct:'+csResponse.data.return_data.info_pct);
                                        // console.log('this.releaseText:'+this.releaseText);
                                        // console.log('this.releasePercent:'+this.releasePercent);

                                        if(csResponse.data.return_data.pct == 100){
                                          this.releaseType = false
                                          status = 0;
                                        }
                                      }
                                    }
                                  });
                              }
                            } else {
                              Swal.fire({
                                icon: 'warning',
                                title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['else']['swal_title'],
                                text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['else']['swal_html'],
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['success']['release']['else']['confirm_button'],
                                timer: 1000
                                // denyButtonText: `Don't save`,
                              }).then((result) => {
                                /* Read more about isConfirmed, isDenied below */
                                if (result.isConfirmed) {
                                  // Swal.fire('Saved!', '', 'success')
                                  this.allPageLoading = true
                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                } else if (result.isDenied) {
                                  // Swal.fire('Changes are not saved', '', 'info')
                                  this.allPageLoading = true
                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                }

                                if (result.dismiss === Swal.DismissReason.timer) {
                                  this.allPageLoading = true
                                  window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                                }
                              })
                            }
                          }, 3000);
                        } else {
                          Swal.fire({
                            icon: 'error',
                            title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_title'],
                            text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_a']+caResponse.data.info+this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['swal_html_b'],
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['warning']['release']['state_failure']['confirm_button'],
                            timer: 5000
                            // denyButtonText: `Don't save`,
                          }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                              // Swal.fire('Saved!', '', 'success')
                              this.allPageLoading = true
                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                            } else if (result.isDenied) {
                              // Swal.fire('Changes are not saved', '', 'info')
                              this.allPageLoading = true
                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                            }

                            if (result.dismiss === Swal.DismissReason.timer) {
                              this.allPageLoading = true
                              window.location.href = "https://dev-private.autoturn.net/target-events-list/f/"+member_hash+"/"+adaccount_id;
                            }
                          })
                        }
                      });
                  }
                })

              }

            }

            if(type == 'suggest'){
                this.showDialog = true;
              }
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['login']['swal_title'],
              text: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang['components']['List']['ListDataTable']['campaignActive']['axios']['login']['confirm_button']
              // denyButtonText: `Don't save`,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                // Swal.fire('Saved!', '', 'success')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                // Swal.fire('Changes are not saved', '', 'info')
                // this.allPageLoading = true
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              }
            })
          }
        });
    },
    onPageCange(event){
      // console.log(event);
    }
  }
};
</script>

<style lang="scss" scoped>

.sub_table {
  display: flex;
  flex-wrap: wrap;
  width: 600px; /* 表格的寬度 */
  border: 1px solid #ccc; /* 表格邊框 */
}
.sub_row {
  display: flex;
  width: 100%;
}
.sub_cell {
  width: 33.33%;
  height: auto; /* 單元格的高度 */
  border: 1px solid #ccc; /* 單元格邊框 */
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 18px 4px;
}
.sub_header {
  background-color: #CBD5E1;
}

.panel {
  width: 98%;
  height: 43vw;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
}

.status-tag {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: auto;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
}

.data-txt {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  color: #404040;
}

.small-txt {
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
  color: #7E7E7E;
}

.grey {
  color: #7E7E7E !important;
  cursor: pointer;
}

.blue {
  color: #1D619F;
  background: #D4E4F6;
}

.green {
  color: #23C647;
  background: #D7F1DD;
}

.red {
  color: #DF062D;
  background: #F4D7DC;
}

.flag {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  background-image: url('../../assets/flag.png');
  background-size: 100% 100%;
  color: white;
  cursor: pointer;
}

.overpanel-title {
  padding: 1rem 1rem;
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  color: #404040;
}

.close-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F6F6F6;
  color: #000000;
  width: 2rem;
  height: 2rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
  position: absolute;
  top: 1.75rem;
  right: 1rem;
  cursor: pointer;
}

</style>